MemberBillingOrgLinkListComponent = require 'views/billing/member-billing-org-link-list-component'
React = require 'react'
t = require('views/internal/recup-with-helpers')('gold_from_bc_info')
track = require 'debug/track'

module.exports = class extends React.Component
  displayName: 'GoldFromBcInfoComponent'

  trackBCLink: ->
    track 'Billing Page', 'Learn more about Business Class from Gold Billing Link Click'

  render: t.renderable ->
    { hasPaidAccount, organizationList } = @props

    t.div '.gold-from-bc-info', =>

      t.div '.gold-from-bc-info-header', ->
        t.h1 '.gold-from-bc-info-header-title', ->
          t.format 'you-have-trello-gold-as-part-of-business-class'

      t.p '.gold-from-bc-info-paragraph.quiet', ->
        t.format 'youre-in-a-team-that-has-trello-business-class-which-includes-all-features-of-gold'

      t.createElement MemberBillingOrgLinkListComponent, { organizationList }

      if hasPaidAccount
        t.p '.gold-from-bc-info-paragraph.quiet', ->
          t.format 'your-trello-gold-subscription-will-not-auto-renew-while-you-have-business-class'

      t.div '.gold-from-bc-info-more', =>
        t.a '.gold-from-bc-info-more-link.quiet-button',
          href: '/business-class'
          target: '_blank'
          onClick: @trackBCLink
        , ->
          t.format 'learn-more-about-business-class'



// WEBPACK FOOTER //
// ./app/scripts/views/billing/gold-from-bc-info-component.coffee